import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { NSInput } from 'bricks';
import { NSInfoBanner } from 'components/NSInfoBanner/NSInfoBanner';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { ISignUpManager } from '../../useSignUpManager';
import { TermsAndConditionsBlock } from '../../../../../components/signup/TermsAndConditionsBlock';

interface ManualSignUpSectionProps {
  onBack: () => void;
  signUpManager: ISignUpManager;
}

const ManualSignUpSection: React.FC<ManualSignUpSectionProps> = ({ onBack, signUpManager }) => {
    const {
        signUpEnabled,
        email,
        password,
        jobTitle,
        name,
        validCaptcha,
        handleEmailChange,
        handlePasswordChange,
        handleJobTitleChange,
        handleNameChange,
        handleSignUp,
    } = signUpManager;

    return (
        <>
            <button
                type="button"
                className="DirectSignUp__SwitchPhaseButton"
                onClick={onBack}
                data-testid="backButton"
            >
                <FontAwesomeIcon icon={faAngleLeft} className="mr-1" />
                {' '}
                Sign up with different method
            </button>
            <div className="DirectSignUp__FormFields">
                <div className="DirectSignUp__InputWrapper">
                    <label htmlFor="name" className="DirectSignUp__SectionLabel">Your information</label>
                    <NSInput
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Enter name"
                        value={name.value}
                        onChange={handleNameChange}
                        className="DirectSignUp__Input"
                        autoComplete="name"
                    />
                </div>
                <NSInput
                    name="email"
                    type="email"
                    placeholder="Enter email"
                    invalid={!!email.errorMsg}
                    showErrorMsg={!!email.errorMsg}
                    errorMsg={email.errorMsg}
                    value={email.value}
                    onChange={handleEmailChange}
                    className="DirectSignUp__Input"
                    autoComplete="email"
                />
                <div className="DirectSignUp__InputRow">
                    <NSInput
                        name="jobTitle"
                        type="text"
                        placeholder="Job title"
                        value={jobTitle.value}
                        onChange={handleJobTitleChange}
                        className="DirectSignUp__Input"
                        autoComplete="job-title"
                    />
                </div>
                <hr className="DirectSignUp__StandaloneDivider" />
                <div className="DirectSignUp__InputWrapper">
                    <label htmlFor="password" className="DirectSignUp__SectionLabel">Password</label>
                    <NSInput
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Enter a strong password"
                        value={password.value}
                        onChange={handlePasswordChange}
                        className="DirectSignUp__Input"
                        autoComplete="current-password"
                        invalid={!!password.errorMsg}
                        errorMsg={password.errorMsg}
                        showErrorMsg={!!password.errorMsg}
                    />
                </div>
                <TermsAndConditionsBlock />
            </div>
            { !validCaptcha && (
                <NSInfoBanner title="Whoops! Seems you are not Human!" warning className="DirectSignUp__InvalidCaptcha" />
            )}
            <div className="DirectSignUp__FormSubmit">
                <NSButtonBase
                    color="primary"
                    callback={handleSignUp}
                    className="DirectSignUp__Button"
                    disabled={!signUpEnabled}
                    dataTestId="signUpButton"
                >
                    Sign up
                </NSButtonBase>
            </div>
        </>
    );
};

export default ManualSignUpSection;
